import { BASE } from "./constants"
// This is a dictionary of all urls to call for the post requests

const BASEAPI = BASE + "/api/"

// When adding a new Url please add it alphabetically and not at the end
const postUrls = {
  activate: "account/activate/",
  askFollowUp: "visit/ask_follow_up/",
  brand: "custom/brand/",
  brandImage: "custom/brand_image/",
  charges: "payment/charges/",
  chargeUser: "payment/charge/",
  crash: "report_crash/",
  configuredExperience: "configuration/",
  customVisit: "custom/visit/",
  deleteAccount: "account/delete/",
  diagnosisFeedback: "visit/dgn_feedback/",
  diagnosisSearch: "visit/parse_diagnosis_query/",
  differentialFeedback: "visit/diff_feedback/",
  emailResults: "visit/email_results/",
  employerCapture: "care/employer_capture/",
  employerNames: "care/employer_names",
  features: "session/features/",
  followUpOptIn: "visit/follow_up_opt_in_or_out/",
  getCardinalSymptoms: "cardinal_symptom_question/",
  getDiagnosisContentPage: "content_relationship/",
  getDashboardRecommendations: "dashboard_recommendations/",
  getEmployer: "account/user_employer",
  getIntegrations: "care/providers/",
  getQuestionExplanation: "visit/explain_question/",
  getSpecialist: "visit/query_specialist/",
  getScreeningIntegrations: "care/screening_providers/",
  getVisitInterview: "visit/visit_interview/",
  getVisitRecommendations: "visit/visit_recommendations/",
  getVisits: "visit/list_visits/",
  getProfileQuestions: "profiles/get_questions/",
  inspectDifferential: "visit/inspect_differential/",
  inspectRestrictions: "visit/inspect_restrictions/",
  interpretSearch: "search/interpret/",
  item: "visit/item/",
  lastAskedNps: "visit/last_asked_nps/",
  loginSubmit: "account/login/",
  logout: "account/logout/",
  marketplacePlans: "marketplace_plans/",
  marketplaceTheme: "marketplace_theme/",
  newVisit: "visit/initialize/",
  nextItem: "visit/next_item/",
  offices: "offices/",
  paymentInfo: "payment/info/",
  peekFollowup: "visit/peek_followup/",
  permissions: "account/permissions/",
  profile: "account/profile/",
  profileInterest: "account/profile_interest_test/",
  planProviders: "plan_providers/",
  plans: "plans/",
  plan_information: "plan_information/",
  questionFeedback: "visit/flag_question/",
  recordAnonymous: "visit/record_anonymous/",
  recordVisitTruth: "visit/visit_truth/",
  regionBasedInsuranceMessages: "visit/region_based_insurance_messages/",
  requestPasswordReset: "account/request_reset/",
  requestReport: "custom/request_report/",
  resetPassword: "account/reset_password/",
  resumeVisit: "visit/resume/",
  results: "visit/result/",
  samlResponse: "saml/sso/response/",
  searchAutocomplete: "search/autocomplete/",
  sendVisit: "visit/send/",
  setPass: "account/register/",
  shouldGetNps: "visit/should_get_nps/",
  signup: "account/signup/",
  signupWithPassword: "account/signup_with_password/",
  startInterview: "visit/close_input/",
  submitAnswer: "visit/submit_answer/",
  submitCardinalEvidence: "visit/submit_evidence/",
  submitClarifier: "search/clarify/",
  submitDiagnosisConcern: "visit/diagnosis_of_concern/",
  submitFailedSearch: "visit/flag_query_interpretations/",
  submitFeedback: "visit/submit_feedback/",
  submitLayterms: "visit/submit_concern/",
  submitLocation: "visit/location/",
  submitNps: "visit/nps/",
  submitUserIntent: "visit/user_intent/",
  recordUserSatisfaction: "product/rating",
  trackCallCTAClick: "care/track_call_cta_click/",
  trackUserDashboardView: "track_user_dashboard_view/",
  trackUserRecommendationAction: "track_user_recommendation_action/",
  tracking: "user_event/",
  updateProfileQuestions: "profiles/update/",
  updateViewedCookiePolicy: "visit/update_viewed_cookie_policy/",
  update_plan_information: "plan_information/update/",
  userIntentCareOptions: "visit/user_intent_care_options/",
  viewedCookiePolicy: "visit/viewed_cookie_policy/",
  visitFromDiagnosis: "visit/visit_from_diagnosis/",
  visitRecommendationUserAction: "visit/visit_recommendation_user_action/",
  visitDiagnosisOfConcernRecommendations:
    "visit/diagnosis_of_concern_recommendations/",
}

// Prepend the base to every URL
for (let x in postUrls) {
  if (postUrls.hasOwnProperty(x)) {
    postUrls[x] = BASEAPI + postUrls[x]
  }
}

postUrls.diagRanksAndPredInfo =
  BASE + "/tools/editor/inspector/get_current_diags_and_pred_info/"
postUrls.attachCase = BASE + "/tools/editor/inspector/attach_case/"

export default postUrls



// WEBPACK FOOTER //
// ./assets/common/urls.js